import React from 'react';
import { bandOf } from '../utils/risk';

/**
 * RiskBar — canonical inline risk-score cell for tables: tabular-nums score
 * next to a thin severity-coloured track. Single source; do not re-implement
 * per page.
 */
export default function RiskBar({ score }) {
  if (score == null) return <span style={{ color: 'var(--text-muted)' }}>—</span>;
  const color = `var(--sev-${bandOf(score)}-fg)`;
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--sp-2)' }}>
      <span style={{
        fontSize: 'var(--fs-md)', fontWeight: 'var(--fw-semi)',
        color, fontVariantNumeric: 'tabular-nums', minWidth: 24, textAlign: 'right',
      }}>
        {score}
      </span>
      <div style={{
        flex: 1, height: 3, minWidth: 60,
        background: 'var(--bg-elevated)', borderRadius: 'var(--radius-xs)', overflow: 'hidden',
      }}>
        <div style={{
          height: '100%', width: `${score}%`, background: color,
          borderRadius: 'var(--radius-xs)',
          transition: 'width var(--dur-slow) var(--ease-out)',
        }}/>
      </div>
    </div>
  );
}
